<template>
	<div class="page-style-a shadow">
		<div class="container" ref="demo">
			<div class="page-intro">
				<h2>Payment Status</h2>
				<ul class="bread-crumb">
					<li class="has-separator">
						<i class="ion ion-md-home"></i>
						<a href="/">Home</a>
					</li>
					<li class="is-marked">
						<a href="">Orders</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
	<Spinner v-if="loading" style="height: 100px" />
	<div v-if="!loading">
		<div class="page-checkout-confirm" v-if="payment_status == 'success'">
			<div class="vertical-center mt-3">
				<div class="text-center">
					<h1><b>Thank you!</b></h1>
					<h5>Order Placed Successfully. Your order ID is : {{ order_id }}</h5>
					<router-link :to="{name: 'Orders'}" class="thank-you-back"
						>My Orders</router-link
					>
				</div>
			</div>
		</div>
		<div class="page-checkout-confirm" v-if="payment_status == 'cancel'">
			<div class="vertical-center mt-3">
				<div class="text-center">
					<h1><b>Payment Declined!</b></h1>
					<h5>Your order is cancelled. Your order ID is : {{ order_id }}</h5>
					<router-link :to="{name: 'Orders'}" class="thank-you-back"
						>My Orders</router-link
					>
				</div>
			</div>
		</div>
	</div>
	<Footer />
</template>

<script>
	import axios from "axios";
	import Footer from "../components/Bottom/Footer.vue";
	import Spinner from "../components/Loaders/Spinner.vue";
	export default {
		components: {Footer, Spinner},
		data() {
			return {
				payment_status: "",
				order_id: "",
				loading: true,
			};
		},
		mounted() {
			if (this.$route.query.order_id) {
				this.order_id = this.$route.query.order_id;
				this.payment_status = this.$route.params.status;
			} else {
				this.$router.push({path: "/404"});
			}
		},
		methods: {
			async ChangeOrderStatus(status) {
				this.loading = true;
				try {
					let {data} = await axios.post(
						process.env.VUE_APP_API_URL + "/api/frontend/update-order-status",
						{order_id: this.order_id, status: status},
						{
							headers: {
								Authorization: `Bearer ${this.token}`,
							},
						}
					);
					console.log(data);
					this.loading = false;
				} catch (error) {
					console.log(error);
					this.loading = false;
					this.$router.push({path: "/404"});
				}
			},
		},

		watch: {
			// 'Pending','Inprocess','Dispatched','Complete', 'Return', 'Cancel', 'Shipped' (0-6)
			payment_status(val) {
				if (val == "success") {
					this.ChangeOrderStatus(1);
					//Payment status changed to 'success' i.e 1
					localStorage.removeItem("conversion"); //Remove conversion value from local storage
				} else if (val == "cancel") {
					this.ChangeOrderStatus(5);
				}
			},
		},
	};
</script>

<style scoped>
	.vertical-center {
		position: unset;
		transform: none;
	}
</style>
